import { Card, Space } from 'antd'
import { useHistogramConfiguration } from 'features/drilldown/components/histogram/contexts/HistogramConfigurationContext'
import { FC, memo } from 'react'

import { HistoAggregationConfigView } from './aggregation/HistoAggregationConfigView'
import { HistoColorConfigView } from './HistoColorConfigView'
import { HistoPlotConfigView } from './HistoPlotConfigView'
import { HistoSortConfigView } from './HistoSortConfigView'
import { HistoStackingConfigView } from './stacking/HistoStackingConfigView'

const RawHistogramConfigurationPanel: FC = () => {
  const { plotType } = useHistogramConfiguration()
  return (
    <Space orientation='vertical' size='middle' style={{ width: '100%' }}>
      <Card title='Data'>
        <HistoAggregationConfigView direction='vertical' />
      </Card>

      <Card title='Visualization'>
        <Space orientation='vertical' style={{ width: '100%' }}>
          <HistoPlotConfigView />
          <HistoSortConfigView />
          <HistoColorConfigView />
        </Space>
      </Card>

      {plotType === 'stacked' && (
        <Card title='Stacking'>
          <HistoStackingConfigView />
        </Card>
      )}
    </Space>
  )
}

export const HistogramConfigurationPanel = memo(RawHistogramConfigurationPanel)
